<template>
    <multiselect
      :value="selected"
      :clear-on-select="clearOnSelect"
      :close-on-select="closeOnSelect"
      :internal-search="internalSearch"
      :loading="loading"
      :custom-label="customLabel"
      :options="options"
      :name="name"
      :placeholder="$t(placeholder)"
      :select-label="$t(selectLabel)"
      :deselectLabel="$t(deselectLabel)"
      :disabled="disabled"
      :track-by="trackBy"

      @open="openSelect(name)"
      @close="closeSelect()"
      @select="selectItem"
      @search-change="asyncFind">
        <div slot="noOptions">
            {{ $t(noOptions) }}
        </div>
        <div slot="noResult">
            {{ $t(noResult) }}
        </div>
    </multiselect>
</template>

<script>
import * as _ from 'underscore'

let searchId;
export default {
    props: {
        value: Object|String,
        noOptions: {
            type: String,
            default: 'print_text_adn_biin'
        },
        noResult: {
            type: String,
            default: 'not_search_result'
        },
        placeholder: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            default: ''
        },
        selectLabel: {
            type: String,
            default: 'select'
        },
        deselectLabel: {
            type: String,
            default: 'selected_remove'
        },
        disabled:{
            type:Boolean,
            default:false,
        },
        clearOnSelect: {
            type: Boolean,
            default: true
        },
        closeOnSelect: {
            type: Boolean,
            default: true
        },
        internalSearch: {
            type: Boolean,
            default: true
        },
        label: { // Ключ имени
            type: String,
            default: 'name'
        },
        customLabel:{
            type: Function,
            default: 'name'
        },
        trackBy: { // Ключ индификатора
            type: String,
            default: 'id'
        },
        apiPath: { // Путь к апи
            type: String,
            default: 'common/'
        },
        apiType: { // Сюда передавать language/, klass/, liter/ обязательно с / если он есть в запросе
            type: String,
            default: ''
        },
        showOpenValues: { // Показывать список всех данных при открытии селекта
            type: Boolean,
            default: true
        },
        limit: { // Лимит списка первых данных
            type: Number,
            default: 15
        },
        innerParams: { // Параметры которые можно передать из вне, они буду включены в запрос к апи
            type: Object,
            default: () => {}
        }
    },
    watch: {
        value(val) {
            this.selected = val
        }
    },
    async mounted() {
        if(this.$route.query[this.name]){
            this.showOpenValues = true;
            await this.openSelect(this.name);

            var find= this.$_.findWhere(this.options, {uid:this.$route.query[this.name]} );
            if(find){
                this.selected = find;
                await this.$emit('input', {name:this.name, select:find,con:false})
            }

        }
    },
    computed: {
        path() {
            return `${this.apiPath}${this.apiType}/`
        },
        is_student(){
            return this.$store.state.user.user.role.is_student
        },
    },
    data() {
        return {
            loading: false,
            options: [],
            selected: this.value,
            searchCheck: false
        }
    },
    methods: {
        async selectItem(val) {
            await this.$emit('input', {name:this.name, select:val,con:true} );
        },
        closeSelect() {
            if(this.searchCheck)
                this.options = []
        },
        async openSelect(name) {
            if(name == 'acad_period'){
                this.options = []
                var objInnerParams = {
                    study_plan:this.$route.query.study_plan,
                    study_year:this.$route.query.study_year
                }
            }

            if(this.showOpenValues) {
                try {
                    this.loading = true
                    const { data } = await this.$http.get(this.path, {
                        params: {
                            ...objInnerParams,
                            my:"1"
                        }
                    })

                    if(data && data.length)
                        this.options = data
                } catch(e) {
                    console.log(e)
                    this.loading = false
                } finally {
                    this.loading = false
                }
            }
        },
        asyncFind(val) {
            this.searchCheck = true
            if(val.length) {
                clearTimeout(searchId)
                searchId = setTimeout(async () => {
                    try {
                        this.loading = true
                        const { data } = await this.$http.get(this.path, {
                            params: {
                                ...this.innerParams,
                                search: val,
                            }
                        })
                        if(data && data.length)
                            this.options = data
                    } catch(e) {
                        console.log(e)
                        this.loading = false
                    } finally {
                        this.loading = false
                    }
                }, 400)
            } else {
                this.openSelect()
            }
        }
    }
}
</script>
